<ng-container *ngIf="cureentUrl == '/smartClassroom'; else normalLayout">
    <router-outlet></router-outlet>
</ng-container>


<ng-template #normalLayout>

    <div *ngIf=" this.cureentUrl == '/privacy_policy'">

        <div>
            <nav *ngIf="user">
                <app-sidebar (valueChange)="fullscreenMethod($event)"></app-sidebar>
            </nav>

            <section class=" dashboard_part"
                [ngClass]="fullscreenData ? 'footer_part_fullscreen main_content_fullscreen ' : 'main_content'">

                <mat-toolbar *ngIf="user" class="nav_bar">

                    <div class="col-md">
                        <span class="nav_header" *ngIf="baseURL.includes(67)">Bandhan Health Program (Dev)</span>
                        <span class="nav_header" *ngIf="baseURL.includes(71) || baseURL.includes('test')">Bandhan Health
                            Program (Test)</span>
                        <span class="nav_header" *ngIf="baseURL.includes(102)">Bandhan Health Program (Staging)</span>
                        <span class="nav_header" *ngIf="baseURL.includes('training')">Bandhan Health Program
                            (Training)</span>
                        <span class="nav_header" *ngIf="baseURL.includes('prod')">Bandhan Health Program</span>
                    </div>
                    <div class="col-md">
                        <span class="close" style="float: right;"> <i class="fas fa-user-circle nav_user_icon"
                                mat-button [matMenuTriggerFor]="menu" title="My Profile"></i></span>
                    </div>

                    <mat-menu #menu="matMenu">
                        <div class="userMenu">
                            <div class="userMenu"
                                style="background-color: #499; padding: 10px 25px; margin-top: -15px;">
                                <span style="color: #ffff;font-weight: 500;font-size: medium;"> Welcome </span>
                                <span style="color: #ffff;font-weight: 500;font-size: medium;">
                                    {{user.responseObject.userdetailDTO.userFirstName}}
                                    {{user.responseObject.userdetailDTO.userMiddleName}}
                                    {{user.responseObject.userdetailDTO.userLastName}}
                                    ({{user.responseObject.RoledetailDTO.roleShortName}})
                                </span>
                            </div>
                            <span> Login ID: {{user.responseObject.userdetailDTO.loginId}}</span>
                            <p (click)="openChangePassword()" class="changePassword">Change Password </p>
                            <button class="btn btn-danger" style="padding: 3px;" (click)="logout()"> <i
                                    class="fa fa-power-off"></i>Logout</button>
                        </div>
                    </mat-menu>
                </mat-toolbar>

                <div class="main_content_inner">
                    <router-outlet></router-outlet>
                </div>

            </section>
        </div>

    </div>

    <div *ngIf=" this.cureentUrl != '/privacy_policy'">

        <div *ngIf="isDonorView">

            <div class="webaccess">

                <nav *ngIf="user">
                    <!-- Top Toolbar -->
                    <app-top-toolbar (valueChange)="onLogoutDonor($event)"></app-top-toolbar>

                    <app-donor-sidebar (valueChange)="fullscreenMethod($event)"></app-donor-sidebar>
                </nav>

                <section class=" dashboard_part"
                    [ngClass]="fullscreenData ? 'footer_part_fullscreen main_content_fullscreen ' : 'main_content'">

                    <mat-toolbar *ngIf="user" class="nav_bar"></mat-toolbar>

                    <div class="main_content_inner">
                        <router-outlet></router-outlet>
                    </div>

                </section>

            </div>


            <h1 class="notSupport">**Not Supported In This Browser Or Change Settings**</h1>
        </div>

        <div *ngIf="!isDonorView">
            <div class="webaccess">
                <nav *ngIf="user">
                    <app-sidebar (valueChange)="fullscreenMethod($event)"></app-sidebar>
                </nav>

                <section class=" dashboard_part"
                    [ngClass]="fullscreenData ? 'footer_part_fullscreen main_content_fullscreen ' : 'main_content'">

                    <mat-toolbar *ngIf="user" class="nav_bar">

                        <div class="col-md">
                            <span class="nav_header" *ngIf="baseURL.includes(67)">Bandhan Health Program (Dev)</span>
                            <span class="nav_header" *ngIf="baseURL.includes(71) || baseURL.includes('test')">Bandhan
                                Health
                                Program (Test)</span>
                            <span class="nav_header" *ngIf="baseURL.includes(102)">Bandhan Health Program
                                (Staging)</span>
                            <span class="nav_header" *ngIf="baseURL.includes('training')">Bandhan Health Program
                                (Training)</span>
                            <span class="nav_header" *ngIf="baseURL.includes('prod')">Bandhan Health Program</span>
                        </div>
                        <div class="col-md">
                            <span class="close" style="float: right;"> <i class="fas fa-user-circle nav_user_icon"
                                    mat-button [matMenuTriggerFor]="menu" title="My Profile"></i></span>
                        </div>

                        <mat-menu #menu="matMenu">
                            <div class="userMenu">
                                <div class="userMenu"
                                    style="background-color: #499; padding: 10px 25px; margin-top: -15px;">
                                    <span style="color: #ffff;font-weight: 500;font-size: medium;"> Welcome </span>
                                    <span style="color: #ffff;font-weight: 500;font-size: medium;">
                                        {{user.responseObject.userdetailDTO.userFirstName}}
                                        {{user.responseObject.userdetailDTO.userMiddleName}}
                                        {{user.responseObject.userdetailDTO.userLastName}}
                                        ({{user.responseObject.RoledetailDTO.roleShortName}})
                                    </span>
                                </div>
                                <span> Login ID: {{user.responseObject.userdetailDTO.loginId}}</span>
                                <p (click)="openChangePassword()" class="changePassword">Change Password </p>
                                <button class="btn btn-danger" style="padding: 3px;" (click)="logout()"> <i
                                        class="fa fa-power-off"></i>Logout</button>
                            </div>
                        </mat-menu>
                    </mat-toolbar>

                    <div class="main_content_inner">
                        <router-outlet></router-outlet>
                    </div>

                </section>
            </div>

            <h1 class="notSupport">**Not Supported In This Browser Or Change Settings**</h1>
        </div>

    </div>

</ng-template>